import BuyFactorSadan from "./BuyFactorSadan";

export default BuyFactorSadan;
